<template>
  <el-row class="login-container">
    <el-col :lg="16" :sm="12" class="login-left">
      <div class="login-left-box">
        <div class="box-txt1">欢迎光临DEMP系统</div>
        <div class="box-txt2">
          DEMP是一款数字化能源管理平台，主要对燃气发电、溴化锂制冷、磁悬浮冷水机组、相变储能的模块化分布式能源系统和PVTV多能源互补系统的智慧管理软件平台
        </div>
      </div>
    </el-col>
    <el-col :lg="8" :sm="12" class="login-right">
      <div class="border border-gry-500 rounded-2xl p-8">
        <h2 class="right-h">欢迎回来</h2>
        <div class="login-right-box">
          <span class="span-txt"></span>
          <span class="text-gray-300">账号密码登录</span>
          <span class="span-txt"></span>
        </div>
        <el-form
          class="w-[250px]"
          ref="loginFormRef"
          :model="loginForm"
          :rules="loginRules"
          @keypress.enter="handleLogin"
        >
          <el-form-item prop="username">
            <el-input v-model="loginForm.username" placeholder="请输入用户名">
              <template #prefix>
                <el-icon>
                  <Avatar />
                </el-icon>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              type="password"
              v-model="loginForm.password"
              placeholder="请输入密码"
            >
              <template #prefix>
                <el-icon>
                  <Lock />
                </el-icon>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              color="#8b5cf6"
              :loading="btnLoading"
              class="w-[250px]"
              type="primary"
              @click="handleLogin"
              >登 录</el-button
            >
          </el-form-item>
        </el-form>
      </div>

      <div class="absolute bottom-4 text-xs text-gray-500">
        <div>
          <a href="https://beian.miit.gov.cn" target="_blank"
            >DEMP数字化能源管理平台©2024 粤ICP备2024336346号</a
          >
        </div>
      </div>
    </el-col>
  </el-row>
</template>
<script setup>
import { reactive, ref } from "vue";
import { useMessage } from "@/hooks/useMessage";
import { useStore } from "vuex";
import { useRouter } from "vue-router";

const store = useStore();
const router = useRouter();

// 登录的表单数据
const loginForm = reactive({
  username: "",
  password: "",
  // captchaSuccess: false,
});
// 获取到表单元素
const loginFormRef = ref(null);
// 登录表单的校验规则
const loginRules = reactive({
  username: [{ required: true, message: "请输入用户名", trigger: "blur" }],
  password: [
    { required: true, message: "请输入密码", trigger: "blur" },
    {
      min: 6,
      max: 20,
      message: "密码必须是6位以上的字母或者数字",
      trigger: "blur",
    },
  ],
});
// 登录按钮的加载loading
const btnLoading = ref(false);

// 点击登录按钮，处理登录
const handleLogin = () => {
  // 表单验证
  loginFormRef.value.validate((valid) => {
    if (!valid) {
      return false;
    }
    // 开启loding
    btnLoading.value = true;
    // vuex登录
    store
      .dispatch("user/loginAction", loginForm)
      .then((res) => {
        // console.log("动态路由：", router.getRoutes());
        router.push("/");
        // useMessage("登录成功");
      })
      .catch((error) => {})
      .finally(() => {
        // 关闭loding
        btnLoading.value = false;
      });
  });
};
</script>

<style scoped lang="scss">
.login-container {
  @apply h-screen;

  .login-left {
    @apply bg-violet-500 flex items-center justify-center <md:h-1/5;

    .login-left-box {
      @apply <md:text-center px-4;

      .box-txt1 {
        @apply font-bold text-3xl xl:text-5xl text-light-50 mb-4;
      }

      .box-txt2 {
        @apply text-gray-200 text-sm;
      }
    }
  }

  .login-right {
    @apply bg-light-50 flex items-center justify-center flex-col <md:h-4/5;

    .right-h {
      @apply font-bold text-center text-3xl text-gray-800;
    }

    .login-right-box {
      @apply flex items-center justify-center my-5 space-x-2;

      .span-txt {
        @apply h-[1px] w-16 bg-gray-200;
      }
    }
  }
}
</style>
